import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, Validators, FormGroup, FormGroupDirective, NgForm } from '@angular/forms';
import { MustMatch } from 'src/app/shared/validators/mustmatch-validator';
import { AuthService } from 'src/app/services/auth.service';
import { AccountService } from 'src/app/services/account.service';
import { SnackBarIconService } from '../../shared/snack-bar-icon/snack-bar-icon.service';
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. */
export class AccountErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-account-password',
  templateUrl: './account-password.component.html',
  styleUrls: ['./account-password.component.scss']
})
export class AccountPasswordComponent implements OnInit {
  
  public matcher = new AccountErrorStateMatcher();
  public accountForm: FormGroup;
  public success:boolean = false; // caso oacesso ao firestore seja negado não exibe o formulario
  public spinner: boolean = false;
  private currentUser: any
  
  constructor( 
    private fb: FormBuilder, 
    private _authService: AuthService,
    private _accountService: AccountService,
    private snackBar: SnackBarIconService ) { }

  ngOnInit() {
    this.currentUser = this._authService.getLogged()
    this.accountForm = this.makeForm()
    this.success = true;
  }

  update() {
    if (this.accountForm.valid) {
      this.spinner = true;
      
      this._accountService.changePassword(this.currentUser.uid, this.accountForm.value.password )
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
          this._authService.SignOut()
        })
        .catch((error) => {
          console.log("user change password error: " + JSON.stringify(error))
          let msgError: string = this._accountService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  makeForm() {
    return this.fb.group({
      password: new FormControl('', [Validators.required]),
      confirm: new FormControl('', [Validators.required]),
    }, { validator: MustMatch('password', 'confirm') });

  }
  
}
